import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/promotions/components/ScratchGamePage/index.tsx");
